import { useState, useEffect } from "react";

import { Button } from "@/components/ui/button";

// Styles Constants based on Figma Design
const STYLES = {
  successTitle: {
    fontSize: "18px",
    lineHeight: "18px",
    color: "#02820A"
  },
  description: {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#000000"
  },
  button: {
    width: "108px",
    height: "32px",
    padding: "7px 0",
    background: "#0068B8",
    boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.25)",
    fontSize: "15px",
    lineHeight: "15px",
    color: "#FFF8F8",
    borderRadius: "4px"
  }
} as const;

interface EmailSentConfirmationProps {
  onResend: () => void;
  onBack?: () => void;
}

const EmailSentConfirmation = ({
  onResend,
  onBack
}: EmailSentConfirmationProps) => {
  const [countdown, setCountdown] = useState(120); // 2 دقیقه = 120 ثانیه
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setIsResendDisabled(false);
    }
  }, [countdown]);

  const handleResend = () => {
    onResend();
    // ریست تایمر بعد از ارسال مجدد
    setCountdown(120);
    setIsResendDisabled(true);
  };

  // فرمت کردن زمان به دقیقه:ثانیه
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="w-full space-y-6 sm:space-y-8">
      {/* Success Header */}
      <div className="space-y-4 text-center">
        <h2 className="font-normal" style={STYLES.successTitle}>
          پست الکترونیکی شما با موفقیت ثبت گردید.
        </h2>
      </div>

      {/* Description */}
      <div className="space-y-4">
        <p
          className="text-right font-normal leading-relaxed"
          style={STYLES.description}
        >
          لطفاً صندوق ورودی پست الکترونیکی خود را بررسی نمایید؛ پیام حاوی لینک
          تایید به آدرس پست الکترونیکی شما ارسال شده است. برای تکمیل فرآیند
          ثبت‌نام، لازم است بر روی لینک مذکور کلیک نمایید. در صورت عدم دریافت،
          خواهشمند است پوشه هرزنامه (Spam) را نیز کنترل فرمایید.
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-between gap-2">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="flex items-center gap-1 text-sm transition-opacity hover:opacity-80"
            style={{
              color: "#0068B8",
              fontSize: "14px"
            }}
          >
            <span>→</span>
            <span>بازگشت</span>
          </button>
        )}

        <Button
          type="button"
          onClick={handleResend}
          disabled={isResendDisabled}
          className="flex items-center justify-center font-normal transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
          style={STYLES.button}
        >
          {isResendDisabled ? formatTime(countdown) : "ارسال مجدد"}
        </Button>
      </div>
    </div>
  );
};

export default EmailSentConfirmation;
